import { render, staticRenderFns } from "./MultiSearchSelect.vue?vue&type=template&id=56051a38&"
import script from "./MultiSearchSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports